export interface RuntimeConfig {
  REACT_APP_SERVER_URL: string;
  REACT_APP_STAGE: string;
  REACT_APP_DD_ENV: string;
  REACT_APP_DD_CLIENT_TOKEN: string;
}

let config: RuntimeConfig | null = null;

function assertRequiredRuntimeConfig(runtimeConfig: RuntimeConfig): void {
  if (!runtimeConfig.REACT_APP_SERVER_URL) {
    throw new Error('REACT_APP_SERVER_URL is required');
  }
  if (!runtimeConfig.REACT_APP_STAGE) {
    throw new Error('REACT_APP_STAGE is required');
  }
  if (!runtimeConfig.REACT_APP_DD_ENV) {
    throw new Error('REACT_APP_DD_ENV is required');
  }
}

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (config) {
    return config;
  }

  const response = await fetch('/runtime-config');
  if (!response.ok) {
    throw new Error(`Failed to load runtime config: ${response.status}`);
  }

  const loadedConfig: RuntimeConfig = await response.json();
  assertRequiredRuntimeConfig(loadedConfig);
  config = loadedConfig;
  return config;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!config) {
    throw new Error(
      'Runtime config not loaded. Call loadRuntimeConfig() before rendering the app.',
    );
  }
  return config;
}
